import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { followUserApi } from "../../services/feedApis";
import SearchResultCard from "./SearchResultCard";
import { DoctorCard } from "./DoctorsResultsComp";

export default function AccountResultsComp({
  data,
  loading,
  id,
  title,
  icon,
  fallbackName,
  getSubtitle,
}) {
  const [searchData, setSearchData] = useState(data);

  useEffect(() => {
    setSearchData(data);
  }, [data]);

  const handleFollow = async (accountId, event) => {
    event?.preventDefault();
    event?.stopPropagation();

    const account = searchData?.find((item) => item?.id === accountId);
    const isFollowed = Boolean(account?.follow || account?.is_following);

    try {
      const response = await followUserApi(accountId);
      if (response.status) {
        toast.success(response.message);
        setSearchData((currentData) =>
          currentData?.map((item) =>
            item?.id === accountId
              ? { ...item, follow: !isFollowed, is_following: !isFollowed }
              : item
          )
        );
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  if (!loading && (!searchData || searchData.length === 0)) {
    return null;
  }

  return (
    <SearchResultCard
      id={id}
      icon={icon}
      title={title}
      count={searchData?.length}
    >
      {loading ? (
        <div className="search-doctors-list">
          {[1, 2, 3].map((number) => (
            <div key={number} className="search-doctor-card">
              <div className="search-doctor-profile-link">
                <div className="search-doctor-avatar-wrap search-shimmer-box" />
                <div className="search-doctor-info" style={{ width: "60%" }}>
                  <div className="search-shimmer-box mb-2" style={{ height: "15px", width: "70%" }} />
                  <div className="search-shimmer-box" style={{ height: "12px", width: "45%" }} />
                </div>
              </div>
              <div className="search-shimmer-box" style={{ height: "32px", width: "80px", borderRadius: "999px" }} />
            </div>
          ))}
        </div>
      ) : (
        <div className="search-doctors-list">
          {searchData.map((item, index) => (
            <DoctorCard
              key={item?.id || index}
              item={item}
              onFollow={handleFollow}
              fallbackName={fallbackName}
              subtitle={getSubtitle?.(item)}
            />
          ))}
        </div>
      )}
    </SearchResultCard>
  );
}
